// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"88dc30ea","239":"f6ff25b4","455":"0a21e6e0"}[chunkId] + ".chunk.js";
};